import { Routes } from '@angular/router';
import { ShortLinkComponent } from './pages/short-link/short-link.component';
import { CheckCIDGuard } from './_shared/guards';
// Blad nawigacji (np. pad lazy-load w SSR) konczy sie cichym pustym
// router-outletem ze statusem 200 - bez loga niewykrywalny (incydent
// countup.js/ESM + "Runtime compiler is not loaded" 2026-07). Log + rethrow
// zachowuje domyslna semantyke bledu.
export function routerErrorLogger(error) {
    console.error('[Router] NavigationError:', error && error.message ? error.message : error);
    throw error;
}
const ɵ0 = {
    title: 'przekierowanie ...'
}, ɵ1 = {
    title: 'Porównaj ceny gazu dla firm',
    description: 'Ten sam gaz, ta sama rura - niższa cena. Porównaj oferty sprzedawców ' +
        'gazu dla firm i przestań przepłacać. Szybko i bez zobowiązań.'
}, ɵ2 = () => import("./pages/product/product.module.ngfactory").then(m => m.ProductModuleNgFactory), ɵ3 = {
    title: 'Porównaj ceny prądu dla firm',
    description: 'Sprawdź w 2 minuty, gdzie Twoja firma zapłaci najmniej za prąd. ' +
        'Realne oferty sprzedawców, oszczędności do 30% rocznie. Bez zobowiązań.'
}, ɵ4 = () => import("./pages/product/product.module.ngfactory").then(m => m.ProductModuleNgFactory), ɵ5 = {
    title: 'Dobierz fotowoltaikę dla firmy',
    description: 'Porównaj oferty sprawdzonych instalatorów PV, poznaj realny czas ' +
        'zwrotu i uniezależnij firmę od podwyżek cen prądu.'
}, ɵ6 = () => import("./pages/product/product.module.ngfactory").then(m => m.ProductModuleNgFactory);
const routes = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: '/prad'
    },
    {
        path: 'e/:base64',
        canActivate: [CheckCIDGuard],
        component: ShortLinkComponent,
        data: ɵ0
    },
    // {
    //   path: 'program-partnerski',
    //   canActivate: [CheckCIDGuard],
    //   data: {
    //     title: 'Program partnerski',
    //     description: 'Zarabiaj na poleceniach porównywarki energii. Dołącz do naszego programu partnerskiego.'
    //   },
    //   loadChildren: () =>
    //     import('./pages/af-program/af-program.module').then(m => m.AfProgramModule)
    // },
    // {
    //   path: 'newsletter',
    //   canActivate: [CheckCIDGuard],
    //   data: {
    //     title: 'Newsletter',
    //     description: 'Zapisz się newsletter informacyjny o istotnych zmianach w energetyce. Prowadzisz firmie, szkole, wspólnotę, stowarzyszenie, gospodarstwo rolnym czy JST? Dostęp do świeżych informacji maksymalnie raz w tygodniu'
    //   },
    //   loadChildren: () =>
    //     import('./pages/newsletter/newsletter.module').then(
    //       m => m.NewsletterModule
    //     )
    // },
    // {
    //   path: 'kontakt',
    //   canActivate: [CheckCIDGuard],
    //   data: {
    //     title: 'Kontakt',
    //     description: '📞502 222 922 - Uzyskaj przewagę nad konkurencją. Nasi doradcy udzielają wsparcie w kwestiach energii w Twojej firmie, szkole, wspólnotcie, stowarzyszeniu, gospodarstwie rolnym czy JST.'
    //   },
    //   loadChildren: () =>
    //     import('./pages/contact/contact.module').then(m => m.ContactModule)
    // },
    // Title/description PER BRANZA (nie statyczny "Wirtualny broker energii" dla
    // wszystkich 3) - inaczej Google deduplikuje huby: identyczny <title>/<meta
    // description> => "Duplicate, Google chose different canonical" (fotowoltaika
    // zwijana do gazu mimo poprawnego self-canonical). MetadataService dokleja
    // sufix " | ZatrzymajLicznik.pl" gdy title < 70 znakow.
    {
        path: 'gaz',
        canActivate: [CheckCIDGuard],
        data: ɵ1,
        loadChildren: ɵ2
    },
    {
        path: 'prad',
        canActivate: [CheckCIDGuard],
        data: ɵ3,
        loadChildren: ɵ4
    },
    {
        path: 'fotowoltaika',
        canActivate: [CheckCIDGuard],
        data: ɵ5,
        loadChildren: ɵ6
    },
    { path: '**', redirectTo: '/prad' }
];
export class AppRoutingModule {
}
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6 };
